import { useLayoutEffect, useMemo } from 'react';

import type { SwrOnceHook } from './once.type';

import useSwrMutation from './mutation';

const useSwrOnce: SwrOnceHook = (...[key, fetch, options = {}, deps = []]) => {
  const swrMutation = useSwrMutation(key, fetch, options);

  useLayoutEffect(() => {
    if (!key) {
      return;
    }

    (async () => {
      await swrMutation.trigger();
    })();

    // * NOT depend on `swrMutation` cause infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, ...deps]);

  return useMemo(() => swrMutation, [swrMutation]);
};

export default useSwrOnce;
